import script from "./FreeBooksBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./FreeBooksBlock.vue?vue&type=script&setup=true&lang=ts"

import "./FreeBooksBlock.vue?vue&type=style&index=0&id=7cf6308b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cf6308b"]])

export default __exports__